import { Component } from '@theme/component';

/**
 * Handles copying text to clipboard, from an event like a click.
 * Optionally, reveals a success message after copying.
 * @extends {Component}
 */
const SUCCESS_MESSAGE_DURATION = 4000;

class CopyToClipboardComponent extends Component {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  #resetTimeout;

  copyToClipboard() {
    const copyContent = this.getAttribute('text-to-copy');

    if (!copyContent) return;

    navigator.clipboard.writeText(copyContent);

    const copySuccessMessage = this.refs.copySuccessMessage;

    if (!(copySuccessMessage instanceof HTMLElement)) return;

    copySuccessMessage.textContent = copySuccessMessage.dataset.message ?? '';
    copySuccessMessage.classList.remove('visually-hidden');

    clearTimeout(this.#resetTimeout);
    this.#resetTimeout = setTimeout(() => {
      copySuccessMessage.classList.add('visually-hidden');
      copySuccessMessage.textContent = '';
    }, SUCCESS_MESSAGE_DURATION);
  }

  disconnectedCallback() {
    clearTimeout(this.#resetTimeout);
    super.disconnectedCallback();
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
